import { styled } from '@mui/system';
import { Theme } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const ContainerServices = styled('div')(
    ({ theme }: ParamsStyle) => `
        h5 {
            font-size: 1.125rem;
        }
        
        @media(min-width: ${theme?.breakpoints.values.md}px) {
            h5 {
                font-size: 1.875rem;
            }
        }
`);

export const Nav = styled('nav')(
    ({ theme }: ParamsStyle) => `
        p {
            text-align: right;
            margin: 0 110px 1rem 0;
        }

        span {
            opacity: 0;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            p {
                text-align: left;
                margin: 0 0 1rem 0;
            }

            span {
                opacity: 1;
                margin-right: 18.2rem;
            }
        }
`);

export const ContainerUl = styled('ul')(
    ({ theme }: ParamsStyle) => `
        display: flex;
        flex-direction: column;
        gap: 2.25rem;
`);